// Global
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { classnames } from 'tailwindcss-classnames';
// Components
import Container from 'components/helpers/Container';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';
import { Components } from '.generated/templates/Feature.Components.model';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import LayoutColumnsGrid, { columnCss } from 'components/helpers/LayoutColumnsGrid';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';

export type LayoutFiveColumnProps = Sitecore.Override.ComponentBase &
  Components.Layout.Fields.ColumnLayout;

export type LayoutFiveColumnShellProps = {
  first: JSX.Element;
  second: JSX.Element;
  third: JSX.Element;
  fourth: JSX.Element;
  fifth: JSX.Element;
};

export const LayoutFiveColumnShell = ({
  first,
  second,
  third,
  fourth,
  fifth,
}: LayoutFiveColumnShellProps): JSX.Element => {
  const isEE = useExperienceEditor();
  const firstPlaceholder = first.props.rendering?.placeholders['nmdp-one-fifth-first'];
  const firstPlaceholderIsEmpty = firstPlaceholder?.length === 0;
  const secondPlaceholder = second.props.rendering?.placeholders['nmdp-one-fifth-second'];
  const secondPlaceholderIsEmpty = secondPlaceholder?.length === 0;
  const thirdPlaceholder = third.props.rendering?.placeholders['nmdp-one-fifth-third'];
  const thirdPlaceholderIsEmpty = thirdPlaceholder?.length === 0;
  const fourthPlaceholder = fourth.props.rendering?.placeholders['nmdp-one-fifth-fourth'];
  const fourthPlaceholderIsEmpty = fourthPlaceholder?.length === 0;
  const fifthPlaceholder = fifth.props.rendering?.placeholders['nmdp-one-fifth-fifth'];
  const fifthPlaceholderIsEmpty = fifthPlaceholder?.length === 0;

  return (
    <LayoutColumnsGrid columns={5}>
      {(isEE || !firstPlaceholderIsEmpty) && <div className={columnCss}>{first}</div>}
      {(isEE || !secondPlaceholderIsEmpty) && <div className={columnCss}>{second}</div>}
      {(isEE || !thirdPlaceholderIsEmpty) && <div className={columnCss}>{third}</div>}
      {(isEE || !fourthPlaceholderIsEmpty) && <div className={columnCss}>{fourth}</div>}
      {(isEE || !fifthPlaceholderIsEmpty) && <div className={columnCss}>{fifth}</div>}
    </LayoutColumnsGrid>
  );
};

const LayoutFiveColumn = ({ rendering, fields }: LayoutFiveColumnProps): JSX.Element => {
  if (fields === null || fields === undefined) {
    return <MissingDataSource />;
  }

  const headingProps = propsFromFields(fields);

  return (
    <Container size="standard" dataComponent="authorable/layout/layout-five-column">
      <div className={fields?.description.value ? classnames('mb-8') : ''}>
        <Heading {...headingProps} descriptionClassName={classnames('text-base')} />
      </div>
      <LayoutFiveColumnShell
        first={<PlaceholderWrapper name="nmdp-one-fifth-first" rendering={rendering} />}
        second={<PlaceholderWrapper name="nmdp-one-fifth-second" rendering={rendering} />}
        third={<PlaceholderWrapper name="nmdp-one-fifth-third" rendering={rendering} />}
        fourth={<PlaceholderWrapper name="nmdp-one-fifth-fourth" rendering={rendering} />}
        fifth={<PlaceholderWrapper name="nmdp-one-fifth-fifth" rendering={rendering} />}
      />
    </Container>
  );
};

export default LayoutFiveColumn;
